import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { protectedResources } from 'src/app/auth-config';
import { PPEApprovalDecisionPayload } from 'src/app/shared/model/ppe-request.model';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class PpeApprovalService {
  url = protectedResources.starhealthapi.endpoint;
  constructor(private http: HttpClient) { }

  getInbox(search: string, page: number, max: number) {
    return this.http.get<any>(`${this.url}/Pperequest/approval/inbox?search=${search}&page=${page}&max=${max}`)
      .pipe(map((res: any) => res));
  }

  checkCanReview(id: number) {
    return this.http.get<boolean>(`${this.url}/Pperequest/approval/canreview/${id}`)
      .pipe(map((res: any) => res));
  }

  getDetailForReview(id: number) {
    return this.http.get<any>(`${this.url}/Pperequest/approval/getbyid/${id}`)
      .pipe(map((res: any) => res));
  }

  decide(payload: PPEApprovalDecisionPayload) {
    return this.http.post<any>(`${this.url}/Pperequest/approval/decide`, payload)
      .pipe(map((res: any) => res));
  }

  isApprover(): Observable<boolean> {
    return this.http.get<any>(`${this.url}/Pperequest/approval/is-approver`)
      .pipe(map((res: any) => res.Data === 'True'));
  }
}